export default __webpack_public_path__ + "static/media/work-1.b56e04de.png";